import {
  LuActivity, LuBellRing, LuChartColumn, LuChartLine, LuCirclePlus, LuFileText, LuGraduationCap,
  LuHeartPulse, LuHistory, LuSparkles, LuSwords, LuTable, LuUserRound, LuUsers,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('sentiment', '/sentiment', 'sentiment_analysis', [
    ['tabs', 'sentiment.tabs', LuHeartPulse],
    ['summary', 'sentiment.summary', LuSparkles, opt],
    ['impact', 'sentiment.impact', LuActivity, { placement: 'top', ...opt }],
  ]),
  tour('sentiment_journey', '/sentiment/journey', 'sentiment_analysis', [
    ['partner', 'sentiment_journey.partner', LuUserRound],
    ['trend', 'sentiment_journey.trend', LuChartLine, { placement: 'top', ...opt }],
    ['timeline', 'sentiment_journey.timeline', LuHistory, { placement: 'left', ...opt }],
  ]),
  tour('sentiment_coaching', '/sentiment/coaching', 'sentiment_analysis', [
    ['intro', 'sentiment_coaching.intro', LuGraduationCap],
    ['chart', 'sentiment_coaching.chart', LuChartColumn, { placement: 'top', ...opt }],
    ['agents', 'sentiment_coaching.agents', LuUsers, { placement: 'top', ...opt }],
  ]),
  tour('sentiment_competitors', '/sentiment/competitors', 'sentiment_analysis', [
    ['intro', 'sentiment_competitors.intro', LuSwords],
    ['table', 'sentiment_competitors.table', LuTable, { placement: 'top', ...opt }],
    ['chart', 'sentiment_competitors.chart', LuChartColumn, { placement: 'top', ...opt }],
  ]),
  tour('sentiment_briefings', '/sentiment/briefing-history', 'sentiment_analysis', [
    ['history', 'sentiment_briefings.history', LuFileText],
    ['list', 'sentiment_briefings.list', LuHistory, { placement: 'top', ...opt }],
  ]),
  tour('sentiment_settings', '/sentiment/settings', 'sentiment_analysis', [
    ['rules', 'sentiment_settings.rules', LuBellRing],
    ['new', 'sentiment_settings.new', LuCirclePlus],
  ]),
];

export default tours;
